import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Collections } from './pages/Collections';
import { ContentList } from './pages/ContentList';
import { ContentEditor } from './pages/ContentEditor';
import { Media } from './pages/Media';
import { SchemaBuilder } from './pages/SchemaBuilder';
import { Login, Settings, Projects } from './pages';
import { useAuthStore } from './stores/auth';

export function App() {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />

                {isAuthenticated ? (
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Dashboard />} />
                        <Route path="projects" element={<Projects />} />
                        <Route path="collections" element={<Collections />} />
                        <Route path="collections/:collectionId" element={<ContentList />} />
                        <Route path="collections/:collectionId/new" element={<ContentEditor />} />
                        <Route path="collections/:collectionId/:contentId" element={<ContentEditor />} />
                        <Route path="media" element={<Media />} />
                        <Route path="schema" element={<SchemaBuilder />} />
                        <Route path="settings" element={<Settings />} />
                    </Route>
                ) : (
                    <Route path="*" element={<Navigate to="/login" replace />} />
                )}
            </Routes>
        </BrowserRouter>
    );
}
